import React from 'react';

const Header = ({ 
  userId, 
  userType, 
  onSignOut, 
  onToggleAdminView, 
  adminView, 
  selectedModule,
  showSubtopicModal,
  onBack,
  isInChatSession
}) => {
  return (
    <>
      <div className="header-top-left-logo">
        <a href={process.env.REACT_APP_LANDING_URL}>
          <img
            className="top-left-logo"
            src="/images/cc-name.png"
            alt="CC logo"
          />
        </a>
      </div>
      <h1 className="chat-header"> </h1>
      
      {/* Top Buttons */}
      {userId && (
        <div className="top-buttons">
          <button className="signout-button" onClick={onSignOut}>
            Sign Out
          </button>

          {userType === 'supervisor' && (
            <button className="toggle-view-button" onClick={onToggleAdminView}>
              Switch to {adminView ? 'App View' : 'Admin View'}
            </button>
          )}

          {selectedModule && !adminView && !showSubtopicModal && (
            <button className="back-button" onClick={onBack}>
              ← Back to Modules
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default Header;
